<template lang="">
  <table class="w-full border">
    <thead>
      <tr>
        <td></td>
        <td class="font-bold">Length/Width/Depth</td>
        <td class="font-bold">Weight</td>
        <td class="font-bold">Volume</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="font-bold">Product Dimensions</td>
        <td>
          {{ +productDimensions.length }} x {{ +productDimensions.width }} x
          {{ +productDimensions.depth }}
        </td>
        <td>{{ productDimensions.weight }}</td>
        <td>{{ productDimensions.volume }}</td>
      </tr>
      <tr>
        <td class="font-bold">Packaging Dimensions</td>
        <td>
          {{ +packagingDimensions.length }} x {{ +packagingDimensions.width }} x
          {{ +packagingDimensions.depth }}
        </td>
        <td>{{ +packagingDimensions.weight }}</td>
        <td>{{ +packagingDimensions.volume }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "SpecsTable",
  props: {
    productDimensions: Object,
    packagingDimensions: Object,
  },
};
</script>
<style scoped>
tr {
  @apply border-b font-medium p-4 pl-8 pt-0 pb-3 text-left;
}

td {
  @apply p-3 text-center border-r
}

td:first-child {
  @apply border-r font-bold w-min 
}
</style>
